import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import {
  validateNumber,
  validatePresence,
} from 'ember-changeset-validations/validators';
import { isBlank } from '@ember/utils';
import moment from 'moment';

const VALIDATION = {
  annualGoal: [
    validatePresence({ presence: true, message: "Can't be blank" }),
    validateNumber({ gte: 1, message: 'Must be a positive number' }),
  ],
  goalDate: [validatePresence({ presence: true, message: "Can't be blank" })],
};

export default class OneTimeFundGoalRoute extends Route {
  @service abilities;
  @service navbarSettings;
  @service store;

  beforeModel(transition) {
    if (this.abilities.noAbility('edit_goal')) {
      transition.abort();
    }
  }

  async model() {
    let record =  (await this.store.query('total-fund-goal', {})).slice()[0];
    if (record) {
      this.navbarSettings.title =  'Edit Total Goal';
    } else {
      this.navbarSettings.title =  'Add Total Goal';
      record = this.store.createRecord('total-fund-goal');
    }
    let changeset = Changeset(
      record,
      lookupValidator(VALIDATION),
      VALIDATION,
    );
    if (isBlank(record.goalDate)) {
      changeset.set('goalDate', moment().add(6, 'months').endOf('month').toDate());
    }
    return {
      record,
      changeset,
    };
  }
}
